import type React from 'react';
import { ErrorBoundary } from '../../../../components/ErrorBoundary';
import { dummyComponentNode } from '../../../../consts/component';

export function maybeWrapInErrorBoundary(
  content: React.ReactNode,
  shouldSkip: boolean,
): React.ReactNode {
  if (shouldSkip) {
    return content;
  }
  return <ErrorBoundary fallback={dummyComponentNode}>{content}</ErrorBoundary>;
}
